import React from "react";
import { Guide } from "../../types/guide";
import {
    alignRight,
    badgeStyle,
    cardStyle,
    componentGridHeader,
    componentGridRow,
    emptyTextStyle,
    mutedTextStyle,
} from "../GuideDetailModal.styles";
import { formatCurrency } from "../GuideDetailModal.utils";

export function PackagesTab({ guide }: { guide: Guide }) {
    const packages = guide.onboarding?.packages ?? [];

    if (!packages.length) {
        return <div style={emptyTextStyle}>No packages have been created.</div>;
    }

    return (
        <div style={{ display: "grid", gap: 12 }}>
            {packages.map((pkg) => {
                const total = (pkg.components ?? []).reduce((sum, component) => {
                    const qty = component.quantity ?? 0;
                    const price = component.unitPriceDollars ?? 0;
                    return sum + qty * price;
                }, 0);

                return (
                    <div key={pkg.id} style={cardStyle}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                            <div>
                                <div style={{ fontWeight: 600 }}>{pkg.name ?? "Untitled package"}</div>
                                <div style={mutedTextStyle}>
                                    {pkg.durationMonths ? `${pkg.durationMonths}-month offering` : "Duration not provided"}
                                </div>
                            </div>
                            <span
                                style={{
                                    ...badgeStyle,
                                    background: pkg.isActive ? "#2C2731" : "#F2EAC3",
                                    borderColor: "#2C2731",
                                    color: pkg.isActive ? "#FEF6D6" : "#2C2731",
                                }}
                            >
                                {pkg.isActive ? "Active" : "Inactive"}
                            </span>
                        </div>
                        {pkg.description && (
                            <div style={{ color: "#403851", fontSize: 13, marginTop: 8, lineHeight: 1.5 }}>
                                {pkg.description}
                            </div>
                        )}
                        <div style={{ marginTop: 12 }}>
                            <div style={componentGridHeader}>
                                <span>Component</span>
                                <span style={alignRight}>Qty</span>
                                <span style={alignRight}>Unit Price</span>
                                <span style={alignRight}>Subtotal</span>
                            </div>
                            {(pkg.components ?? []).map((component) => {
                                const qty = component.quantity ?? 0;
                                const price = component.unitPriceDollars ?? 0;
                                const subtotal = qty * price;
                                return (
                                    <div
                                        key={component.id ?? component.name ?? component.componentType ?? `${pkg.id}-${subtotal}`}
                                        style={componentGridRow}
                                    >
                                        <span>{component.name ?? component.componentType ?? "Component"}</span>
                                        <span style={alignRight}>{qty || "--"}</span>
                                        <span style={alignRight}>{formatCurrency(price)}</span>
                                        <span style={alignRight}>{formatCurrency(subtotal)}</span>
                                    </div>
                                );
                            })}
                        </div>
                        <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end", fontWeight: 600 }}>
                            Package total: {formatCurrency(total)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
